import { useTranslation } from "react-i18next";
import { useUiStore } from "@/stores/ui-store";
import { cn } from "@/lib/utils";
import { SUPPORTED_UI_LANGUAGES, type UiLanguage } from "@/i18n";

export function LanguageSwitcher() {
  const { t } = useTranslation("common");
  const language = useUiStore((s) => s.language);
  const setLanguage = useUiStore((s) => s.setLanguage);

  return (
    <div
      role="group"
      aria-label={t("language.en") + " / " + t("language.es")}
      className="flex items-center rounded-full bg-secondary h-[18px] overflow-hidden flex-shrink-0"
    >
      {SUPPORTED_UI_LANGUAGES.map((lang) => (
        <button
          key={lang}
          type="button"
          role="radio"
          aria-checked={language === lang}
          onClick={() => setLanguage(lang as UiLanguage)}
          className={cn(
            "h-full px-1.5 text-[10px] font-semibold uppercase leading-none transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            language === lang
              ? "bg-brand text-white rounded-full"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
